$(document).ready(function() {
    $("#facet__btn-deselect > a").click(function() {
        $(".facetbutton").each(function(i, obj) {
            $(this).attr("data-selected", "false");
        });
        $(".facet-responsive__countlabel").each(function() {
            $(this).css("display", "none");
        });
        $(".facet-responsive__span-count").text("");
        countFilter = 0;
    });

    //Facet filter Apply button behavior
    $('div[id*="btn-apply"]').click(function() {
        var hrefFacet = $('div[id*="btn-apply"] > a').attr("href");
        var countFacet = 1;
        var facetsList = [];
        $(".facetbutton").each(function(i, obj) {
            if ($(this).attr("data-selected") === "true" && !facetsList.includes($(this).attr("data-value"))) {
                facetsList.push($(this).attr("data-value"));
                hrefFacet = hrefFacet + "&facet_" + countFacet + "=" + $(this).attr("data-value") + "&facetName_" + countFacet + "=" + $(this).attr("data-name");
                countFacet = countFacet + 1;
            }
        });
        $('div[id*="btn-apply"] > a').attr("href", hrefFacet);
    });

    $(".facet__responsive-title").click(function() {
        $(".facet__list-open").hasClass("opend") ? $(".facet__list-open").removeClass("opend") : $(".facet__list-open").addClass("opend");
    });

    $('.facet-responsive__label').click(function() {
        var inputPrev = $(this).prev();
        if (inputPrev.prop('checked') == true) {
            $(this).parent().find('.facet-responsive__input').prop('checked', false);
        }
    });

    /**
     *  This function is for the orderBy.
     *
     *  When you click on a link, the function will find the string
     *  '&orderBy=' and change it for the one we selected.
     *
     *  If there is no '&orderBy=', it will just concat it at the
     *  end of the url.
    */
    $(".orderBy__5, .orderBy__6, .orderBy__7, .orderBy__8").click(function() {
        var str = $(this)[0].className;
        var res = str.split("__");
        var url = window.location.href;
        var newUrl = "";
        var variable = "";
        var variable1 = "";
        var variable2 = "";
        var link = url.indexOf("?") >= 0 ? "&" : "?";

        if (url.indexOf("?orderBy=") >= 0) {
            variable = window.location.href.slice(0, window.location.href.indexOf("?orderBy="));
            variable1 = url.split("?orderBy=");
            variable2 = variable1[1];
            variable2 = variable2.slice(1);
            newUrl = variable + "?orderBy=" + res[1] + variable2;
        } else if (url.indexOf("&orderBy=") >= 0) {
            variable = window.location.href.slice(0, window.location.href.indexOf("&orderBy="));
            variable1 = url.split("&orderBy=");
            variable2 = variable1[1];
            variable2 = variable2.slice(1);
            newUrl = variable + "&orderBy=" + res[1] + variable2;
        } else {
            newUrl = window.location.href + link + "orderBy=" + res[1];
        }

        window.location.href = newUrl;
    });

    /**
     * Open the differents submenus of the Facet Filter in responsive design
     */
    $(".facet-responsive__label").click(function() {
        if ($(this).hasClass("opend")) {
            $(this).removeClass("opend");
        } else {
            $(".facet-responsive__label").removeClass("opend");
            $(this).addClass("opend");
        }
    });

}).mouseup(function(e) {
    var container = $(".facet__content.opend");
    var container1 = $(".facet__check-sort.opend");
    var container2 = $("[class^='facet__click-'].opend");

    if (
        (!container.is(e.target) && container.has(e.target).length === 0) &&
        (!container1.is(e.target) && container1.has(e.target).length === 0) &&
        (!container2.is(e.target) && container2.has(e.target).length === 0)
    ) {
        container.removeClass('opend');
        container1.removeClass('opend');
        container2.removeClass('opend');
    }
});

//Facets area behavior
$(document).ready(function() {
    showNumberOfSelectedFacetsInEachSection();

    var facetButtons = document.querySelectorAll('.facetbutton');
    for (var i=0; i<facetButtons.length; i++){

        if (parseInt(facetButtons[i].attributes["data-count"].value) == 0){
            $(facetButtons[i]).find('.outline > span').addClass('facet--inactive');
        }
        facetButtons[i].addEventListener('click', function(event){
            var id = this.id;
            var checked = this.dataset.selected;
            checked === "true" ? checked = false : checked = true;

            //clickedFacets will contain 2 items with the same id, one for mobile and one for desktop
            var clickedFacets = document.querySelectorAll("#"+id);
            for (var i=0; i<clickedFacets.length; i++){
                clickedFacets[i].attributes["data-selected"].value = checked;
            }
            showNumberOfSelectedFacetsInEachSection();
        });
    }
});

function showNumberOfSelectedFacetsInEachSection() {
    $('.optionContainer').each(function() {
        var activeFacetsInSection = 0;
        var that = $(this);
        that.find('[data-selected]').each(function() {
            if ($(this).attr('data-selected') == 'true'){
                activeFacetsInSection += 1
            };
        });
        if (activeFacetsInSection === 0) {
            that.find('.facet-responsive__countlabel').hide();
        } else {
            that.find('.facet-responsive__count').text(activeFacetsInSection);
            that.find('.facet-responsive__countlabel').show();
        }
    });
}


/**
 * Responsive Filters
 */
$(document).ready(function() {
    $(".facet-responsive__title-wrapper").click(function() {
        var that = $(this).parent();
        if (that.hasClass("opend")) {
            that.removeClass("opend");
        } else {
            $(".facet-responsive__filter-by, .facet-responsive__sort-by").removeClass("opend");
            that.addClass("opend");
        }
    });

    $(".facet-responsive__wrapper-content-title").click(function() {
        removeAddOpend($(this), ".facet-responsive__wrapper-content-title");
    });

    $(".facet-responsive__label-wrapper").click(function() {
        removeAddOpend($(this), ".facet-responsive__label-wrapper");
    });

    $(".facet__check-sort").click(function() {
        removeAddOpend($(this), ".facet__list-open span");
    });

    $(".facet__click-gender").click(function() {
        removeAddOpend($(this), ".facet__click-gender, .facet__click-frame, .facet__click-lense, .facet__click-brand, .facet__check-sort, .facet__click-product-type");
        visibleFacet("gender");
    });

    $(".facet__click-frame").click(function() {
        removeAddOpend($(this), ".facet__click-gender, .facet__click-frame, .facet__click-lense, .facet__click-brand, .facet__check-sort, .facet__click-product-type");
        visibleFacet("frame");
    });

    $(".facet__click-lense").click(function() {
        removeAddOpend($(this), ".facet__click-gender, .facet__click-frame, .facet__click-lense, .facet__click-brand, .facet__check-sort, .facet__click-product-type");
        visibleFacet("lense");
    });

    $(".facet__click-brand").click(function() {
        removeAddOpend($(this), ".facet__click-gender, .facet__click-frame, .facet__click-lense, .facet__click-brand, .facet__check-sort, .facet__click-product-type");
        visibleFacet("brand");
    });

	$('.facet__click-product-type').click(function() {
		removeAddOpend($(this), '.facet__click-gender, .facet__click-frame, .facet__click-lense, .facet__click-brand, .facet__check-sort, .facet__click-product-type');
		visibleFacet('product-type');
	});

    $(".facet__click-duration").click(function() {
        removeAddOpend($(this), ".facet__click-type, .facet__click-duration, .facet__check-sort");
        visibleFacet("duration");
    });

    $(".facet__click-type").click(function() {
        removeAddOpend($(this), ".facet__click-duration, .facet__click-type, .facet__check-sort");
        visibleFacet("type");
    });
});

function removeAddOpend(that, classRemove) {
    if (that.hasClass('opend')) {
        that.removeClass('opend');
    } else {
        $(classRemove).removeClass('opend');
        that.addClass('opend');
    }
}

function visibleFacet(view) {
    var that = $(".facet__content--" + view);
    if (that.hasClass("opend")) {
        that.removeClass("opend");
    } else {
        $(".facet__content").removeClass("opend");
        that.addClass("opend");
    }
}

$('.product-list__product').slice(0, 48).show(); // select the first ten

$('.product-list__view-more').click(function(e) { // click event for load more
    e.preventDefault();
    $('.product-list__product:hidden').slice(0, 48).show();
    if ($('.product-list__product:hidden').length == 0) { // check if any hidden divs still exist
        $(this).hide();
    }
});

$(document).ready(function() {
    if($('.product-list__product').length < 48){
        $('.product-list__view-more').hide();
    }

    $('.product-list__colors-span').each(function(index, item) {
        $(item).css('background-color', navColors[$(item).attr('data-color').toLowerCase()]);
    });

    $('.product-list__colors-bottom').each(function(index, item) {
        var numColors = 0;
        $(item).children().each(function(index, item) {
            numColors = numColors + 1;
        });
        $(this).prev().find(" > span").first().text(numColors);
        if (numColors == 1){
            var str = $(this).prev().find('.span_colors').text();
            str = str.replace(/(\r\n\t|\n|\r\t)/gm,"").trim();
            str = str.substring(0,str.length - 2);
            $(this).prev().find('.span_colors').text(str);
        }
    });
});

/**
 * To know wich order is selected
 */
(function() {
    var search = window.location.href;
    if (search !== '' && search.includes('orderBy')) {
        var testUrl = new URL(search);
        var paramOrderBy = testUrl.searchParams.get('orderBy');
        var mapOrderBy = document.querySelectorAll('.orderBy__' + paramOrderBy);
        mapOrderBy.forEach(function(item) {
        item.classList.add('selected');
        });
    }
})();

/** Function to show the parameter selected to ORDER BY on PLP and SEARCH pages */
$(document).ready(function() {
    if ($(".facet__sort-by-menu li.selected").length>0){
        var sortbySelectedLabel=$(".facet__sort-by-menu li.selected")[0].textContent;
        $("#sortby-label").text(sortbySelectedLabel);
    }
});